export const INSERTS_CONNECTOR = "insert-connector";
export const TABLE_CONNECTOR = "table-connector";
export const LEFT = "left";
export const RIGHT = "right";
export const ENABLE = "enable";
export const DISABLE = "disable";
export const SIDE_UNIT_LEFT = "side-unit-left";
export const SIDE_UNIT_RIGHT = "side-unit-right";
export const CROSS_BRACE = "cross-brace";
export const ADJUSTABLE_CONNECTOR = "adjustable-connector";
export const ADD = "add";
export const DELETE = "delete";
export const UPDATE = "update";
export const WALL = "WALL";
export const GUEST = "guest";
export const HOST = "host";
export const INSERT = "insert";
export const STATIC = "static";
export const MOVEABLE = "moveable";
export const ROOM = "Room";
export const CEILING = "ceiling";
export const ROOM_SURFACE = "room-surface";
export const INHERITS = "inherits";
